module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "universe-stability"
  }, [_c('div', {
    staticClass: "universe-stability__header"
  }, [_c('h4', {
    ref: "header"
  }, [_vm._v("UNIVERSE STABILITY")]), _vm._v(" "), (!_vm.hideStabilityFlag) ? [(_vm.universeIsStable) ? _c('div', {
    staticClass: "universe-stability__check is-stable"
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.pass,
      "width": 22,
      "height": 22
    }
  }), _vm._v(" " + _vm._s(_vm.stableText) + "\n      ")], 1) : _vm._e(), _vm._v(" "), (!_vm.universeIsStable) ? _c('div', {
    staticClass: "universe-stability__check is-unstable"
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.error,
      "width": 22,
      "height": 22
    }
  }), _vm._v(" " + _vm._s(_vm.unstableText) + "\n      ")], 1) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "universe-stability__graph"
  }, [_c('universe-stability-graph', {
    attrs: {
      "data": _vm.universeChartData
    }
  }), _vm._v(" "), (!_vm.universe) ? _c('api-error-message', {
    attrs: {
      "apiName": "universe stability graph data"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10f173bd","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/lasGraphs/universeStability/components/UniverseStability.vue
// module id = 1998
// module chunks = 0